import { Outlet } from 'react-router-dom';
import { hasAnyJwtAuthority } from '../utils/tokenUtils';
import AdminAccessDenied from '../views/Admin/AdminAccessDenied';

export function hasAnyAdminAuthority(authorities = []) {
    return hasAnyJwtAuthority(authorities);
}

/**
 * Inline guard for a single admin page (use when nested under an already-guarded layout).
 */
export const AdminRoleGate = ({ authorities = [], children }) => {
    if (!hasAnyAdminAuthority(authorities)) {
        return <AdminAccessDenied />;
    }
    return children;
};

/**
 * Reusable route guard for admin pages.
 * Accepts an `authorities` prop — an array of { scope, subject, action } requirement objects.
 * Grants access if the user's JWT matches ANY requirement via hasJwtAuthority().
 */
const AdminRoutes = ({ authorities = [] }) => {
    if (!hasAnyAdminAuthority(authorities)) {
        return <AdminAccessDenied />;
    }

    return <Outlet />;
};

export default AdminRoutes;
